import loadGlobals from './load-files/load-files-globals';
import loadSsrFile from './load-files/load-ssr';
import { Configuration, ConfigurationManifestComponent } from '../typings';
import getFilteredFiles from '../helpers/get-filtered-files';
import EventEmitter from '../event-emitter/event-emitter';

export const SsrLoader = async (config: Configuration) => {
  const ssrFile = getFilteredFiles<ConfigurationManifestComponent>(
    config.files,
    x => x.ssr
  );

  await loadGlobals({ config } as any);
  const loadedSsrFile = await loadSsrFile({ config, files: ssrFile } as any);

  EventEmitter.emit('updateStateLoadedComponents', { loadedSsrFile });

  return { files: loadedSsrFile, ssrLoaded: true };
};
